import { render, staticRenderFns } from "./IpTrafficDetails.vue?vue&type=template&id=398362a4&"
import script from "./IpTrafficDetails.vue?vue&type=script&lang=js&"
export * from "./IpTrafficDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports